/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useEffect } from 'react'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'
import { useRemovePaymentMethodMutation } from 'api/billing'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    id: string | null,
    status: boolean,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function RemovePaymentConfirmationLightbox({ id, status, close }: Props) {
    const [removePaymentMethod, { isSuccess }] = useRemovePaymentMethodMutation()

    useEffect(() => {
        if (isSuccess) {
            close()
        }
    }, [close, isSuccess])

    return (
        <Lightbox
            title={'Remove Payment Method'}
            type={'confirm'}
            icon={'warning'}
            description={'Are you sure you want to remove this payment method?'}
            conditions={{ state: status, action: () => close() }}
            actions={[{
                label: 'Remove',
                color: 'error',
                type: 'submit',
                func: () => removePaymentMethod(id)
            }]}
        />
    )
}
